const getBackendUrl = () => {
  let url = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_backend_baseUrl_live
    : (process.env.REACT_APP_backend_baseUrl_localTest || 'http://localhost:1337');
    
  if (!url) url = 'http://localhost:1337';
  
  // Auto-detect Strapi v5 vs v3 based on port
  if (url.includes(':1337') && !url.endsWith('/api')) {
    return `${url}/api`;
  }
  return url;
};

export const BACKEND_URL = getBackendUrl();

export const FRONTEND_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_susu_baseUrl_live
  : (process.env.REACT_APP_susu_baseUrl_localTest || 'http://localhost:3002');

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/local',
    REGISTER: '/auth/local/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    ME: '/users/me'
  },
  CLOSET: {
    BASE: '/closet-clothes',
    USER_DATA: '/closet-data/user',
    CREATE: '/closet-data/item',
    CREATE_WITH_UPLOAD: '/closet-data/item/upload',
    UPDATE: (id) => `/closet-data/item/${id}`,
    DELETE: (id) => `/closet-data/item/${id}`,
    REMOVE_BG_UPLOAD: '/closet-clothes/removebgFromUpload',
    REMOVE_BG_URL: '/closet-clothes/removebgFromUrl'
  },
  PERSON_IMAGE: {
    BASE: '/person-images',
    UPLOAD: '/person-images/upload',
    CREATE_WITH_FILES: '/person-images/create-with-files',
    USER_IMAGES: (userId) => `/person-images/user/${userId}`,
    LATEST: '/person-images/latest',
    ACTIVATE: (id) => `/person-images/${id}/activate`,
    DEACTIVATE: (id) => `/person-images/${id}/deactivate`,
    UPDATE: (id) => `/person-images/${id}`,
    DELETE: (id) => `/person-images/${id}`,
    VALIDATE: '/person-images/validate',
    RECOMMENDATIONS: '/person-images/recommendations',
    REMOVE_BG_UPLOAD: '/person-images/removebg-upload',
    REMOVE_BG_URL: '/person-images/removebg-url'
  },
  BACKGROUND_IMAGE: {
    BASE: '/background-images',
    UPLOAD: '/background-images/upload',
    PUBLIC_BACKGROUNDS: '/background-images/public',
    CATEGORIES: '/background-images/categories',
    UPDATE: (id) => `/background-images/${id}`,
    DELETE: (id) => `/background-images/${id}`,
    BY_ID: (id) => `/background-images/${id}`
  },
  VTO_RESULT: {
    BASE: '/virtual-try-on-results',
    UPLOAD: '/virtual-try-on-results/upload',
    STATS: '/virtual-try-on-results/stats',
    BY_ID: (id) => `/virtual-try-on-results/${id}`,
    UPDATE: (id) => `/virtual-try-on-results/${id}`,
    DELETE: (id) => `/virtual-try-on-results/${id}`,
    BY_CACHE_KEY: (cacheKey) => `/virtual-try-on-results/cache/${cacheKey}`,
    CLEANUP_EXPIRED: '/virtual-try-on-results/cleanup-expired'
  },
  CREDIT: {
    BALANCE: '/credit/balance',
    REFERRAL: '/credit/referral',
    PACKAGES: '/credit-packages',
    PURCHASE: '/credit-packages/purchase',
    CONFIRM: '/credit-packages/confirm'
  },
  SHARED_RESULT: {
    BASE: '/shared-results',
    BY_TOKEN: (token) => `/shared-results/by-token/${token}`,
    CLAIM: (token) => `/shared-results/${token}/claim`
  },
  SHARE_BUNDLE: {
    BASE: '/share-bundles',
    BY_TOKEN: (token) => `/share-bundles/by-token/${token}`,
    CLAIM: (token) => `/share-bundles/${token}/claim`,
    MINE: '/share-bundles/mine',
    REVOKE: (id) => `/share-bundles/${id}/revoke`
  },
  SHARED_CLOSET: {
    BROWSE: '/shared-closet/browse',
    USER_CLOSET: (userId) => `/shared-closet/user/${userId}`,
    USER_PROFILE: (username) => `/shared-closet/profile/${username}`,
    TOGGLE: (arg1, arg2) => (arg2 !== undefined ? `/shared-closet/toggle/${arg1}/${arg2}` : `/shared-closet/toggle/${arg1}`),
    MY_STATS: '/shared-closet/my-shared-stats',
    CREDIT_COST: (arg1, arg2) => (arg2 !== undefined ? `/shared-closet/credit-cost/${arg1}/${arg2}` : `/shared-closet/credit-cost/${arg1}`),
    PRICING: (entityType, entityId) => `/shared-closet/pricing/${entityType}/${entityId}`
  },
  EARNINGS: {
    SUMMARY: '/try-on-earnings/my-summary',
    HISTORY: '/try-on-earnings/my-history',
    PAYOUT_STATUS: '/try-on-earnings/payout-status',
    AUTO_PAYOUT: '/try-on-earnings/auto-payout'
  },
  STRIPE_CONNECT: {
    CREATE_ACCOUNT: '/stripe/create-account',
    ACCOUNT_SESSION: '/stripe/account-session',
    ACCOUNT_STATUS: '/stripe/account-status'
  },
  SUSU_LICENSE: {
    PURCHASE: '/susu-license/purchase',
    CONFIRM: '/susu-license/confirm',
    CHECK: (entityType, entityId) => `/susu-license/check/${entityType}/${entityId}`,
    MY_PURCHASES: '/susu-license/my-purchases'
  }
};

// Constants
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

// AI Configuration (WebLLM in-browser inference)
export const AI_CONFIG = {
  modelId: 'gemma-3-4b-it-q4f16_1-MLC',
  displayName: 'Gemma 3 4B',
  downloadSizeMB: 2600
};